import React, { FC } from 'react'
import Box from '@mui/material/Box'
import { Link as ScrollLink } from 'react-scroll'
import { navigations } from './navigation.data'

interface NavigationProps {
  onClick?: () => void
}

const navItemSx = {
  position: 'relative' as const,
  color: 'text.disabled',
  cursor: 'pointer',
  fontWeight: 500,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: { xs: 0, md: 3 },
  mb: { xs: 3, md: 0 },
  fontSize: { xs: '1.15rem', md: 'inherit' },
  transition: 'color 0.3s, box-shadow 0.6s',
  marginLeft: '0.2rem',
  '&.current > div': {
    display: 'block',
    transform: 'scaleX(1)',
  },
  '&:hover': {
    color: 'primary.main',
    boxShadow: '0 2px 0 0 currentColor',
    '& > div': {
      display: 'block',
      transform: 'scaleX(1)',
    },
  },
}

const Navigation: FC<NavigationProps> = ({ onClick }) => {
  const handleItemClick = () => {
    onClick?.()
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
      {navigations.map(({ path: destination, label, externalLink }) =>
        externalLink ? (
          <Box
            component="a"
            key={destination}
            href={externalLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleItemClick}
            sx={{
              ...navItemSx,
              textDecoration: 'none',
              '&:hover': { ...navItemSx['&:hover'], color: 'primary.main' },
            }}
          >
            <Box />
            {label}
          </Box>
        ) : (
          <Box
            component={ScrollLink}
            key={destination}
            activeClass="current"
            to={destination}
            offset={-100}
            spy={true}
            smooth={true}
            duration={550}
            onClick={handleItemClick}
            sx={{
              ...navItemSx,
              ...(destination === '/' && { color: 'primary.main' }),
            }}
          >
            <Box />
            {label}
          </Box>
        )
      )}
    </Box>
  )
}

export default Navigation
